import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Checkbox,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import Autocomplete from "@mui/material/Autocomplete";
import Popper from "@material-ui/core/Popper";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";
import AlertDialog from "./AlertDialog.js";
import checkImg from "../assets/icons/check_circle.png";
import { FORM_LIST_FOR_CLIENT_QUERY } from "../graphQL/form_qry";
import { CREATE_FIRST_TERM_MUTATION } from "../graphQL/term_qry";
import { CLIENT_TERM_TEMPLATE_LIST_QUERY } from "../graphQL/term_template_qry";
import { project_url } from "../constants/Data";

var findAnd = require("find-and");

const useStyles = makeStyles(theme => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 30,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
}));
const styles = theme => ({
  popper: {
    width: "fit-content",
  },
});

export default function AddTermInputDialog({ closeDialog, defaultStartDate }) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState({
    termName: "",
    startDate: "",
    form: "",
    noOfSeats: "",
    template: "",
  });
  const [termName, setTermName] = useState("");
  const [termTemplateData, setTermTemplateData] = useState([]);
  const [templateListData, setTemplateListData] = useState([]);
  const [selectedTemplateName, setSelectedTemplateName] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [minDate, setMinDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [noOfSeats, setNoOfSeats] = useState(1);
  const [noOfWeeks, setNoOfWeeks] = useState(null);
  const [clientFormList, setClientFormList] = useState([]);
  const [selectedForm, setSelectedForm] = useState(0);
  const [alertMsg, setAlertMsg] = useState([]);
  const [selectedVal, setSelectedVal] = useState("Select");
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const PopperMy = function (props) {
    return <Popper {...props} style={styles.popper} placement="bottom-start" />;
  };
  let startDateRef = useRef(null);
  let endDateRef = useRef(null);
  let clientId = 1;
  if (localStorage.getItem("clientId")) clientId = localStorage.getItem("clientId");
  let clientName = "";
  if (localStorage.getItem("clientName")) clientName = localStorage.getItem("clientName");
  let tenantId = 1;
  if (localStorage.getItem("tenantId")) tenantId = localStorage.getItem("tenantId");
  const [fetchClinetFormList] = useManualQuery(FORM_LIST_FOR_CLIENT_QUERY, {
    fetchPolicy: "network-only",
  });
  const [getClientTermTemplateData] = useManualQuery(CLIENT_TERM_TEMPLATE_LIST_QUERY, {
    fetchPolicy: "network-only",
  });
  const [createFirstTerm] = useMutation(CREATE_FIRST_TERM_MUTATION, {
    awaitRefetchQueries: true,
  });
  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  useEffect(() => {
    (async () => getFormlist())();
  }, []);

  useEffect(() => {
    (() => getTermTemplateList())();
  }, []);

  useEffect(() => {
    if (errorMsg.startDate) {
      startDateRef.current.focus();
    }
  }, [errorMsg]);

  useEffect(() => {
    if (selectedTemplateName) updateEndDate(startDate);
  }, [noOfWeeks]);

  const handleNameFieldChange = event => {
    if (event.target.value.trim() !== "")
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        termName: "",
      }));
    setTermName(event.target.value);
  };
  const validateNoOfSeats = value => {
    if (parseInt(value) < 1) {
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        noOfSeats: "Enter an integer greater than zero.",
      }));
    } else if (parseInt(value) > 99) {
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        noOfSeats: "Enter an integer less than 99.",
      }));
    } else if (value.toString().trim() === "") {
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        noOfSeats: "No of Seats cannot be blank.",
      }));
    } else {
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        noOfSeats: "",
      }));
      setNoOfSeats(value);
    }
  };

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    const dayDate = new Date(day);
    const dayFormat = formatter.formatToParts(dayDate);

    const newFormat =
      dayFormat.find(a => a.type == "month").value +
      "/" +
      dayFormat.find(a => a.type == "day").value +
      "/" +
      dayFormat.find(a => a.type == "year").value;
    return newFormat;
  };

  const setTermDataByTemplate = termName => {
    if (termName && termName.trim() !== "")
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        template: "",
      }));
    const filtered = templateListData.filter(item => item.name == termName);
    if (filtered.length > 0) {
      setSelectedTemplateName(termName);
      setNoOfSeats(filtered[0].noOfSeats);
      setNoOfWeeks(filtered[0].noOfWeeks.split(" + ")[1]);
    } else {
      setNoOfSeats(1);
      setNoOfWeeks(1);
    }
  };

  const updateStartEndDates = newDate => {
    setStartDate(newDate);
    if (selectedTemplateName) updateEndDate(newDate);
  };

  const updateEndDate = newStartDate => {
    const end = new Date(newStartDate);
    end.setDate(new Date(newStartDate).getDate() + noOfWeeks * 7);
    setEndDate(end.toLocaleDateString("sv-SE"));
  };

  const getTermTemplateList = async () => {
    const {
      loading: termTemplateDataLoading,
      error: termTemplateDataError,
      data: termTemplateData,
    } = await getClientTermTemplateData({
      variables: {
        clientId: parseInt(clientId),
        showAllForList: false,
      },
    });
    if (
      !termTemplateDataLoading &&
      termTemplateData &&
      termTemplateData.clientTermTemplateList
    ) {
      setTemplateListData(termTemplateData.clientTermTemplateList);
      setTermTemplateData(
        termTemplateData.clientTermTemplateList.map(({ name }) => name)
      );
    }
    if (
      termTemplateDataError &&
      termTemplateDataError.graphQLErrors &&
      termTemplateDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }
  };

  const getFormlist = async () => {
    const {
      loading: loadingClientForm,
      error: errorClientForm,
      data: dataClientForm,
    } = await fetchClinetFormList({
      variables: {
        clientId: parseInt(clientId),
      },
    });

    if (!loadingClientForm && dataClientForm && dataClientForm.formListForClient) {
      let formList = dataClientForm.formListForClient.map(item => ({
        ...item,
        checked: false,
        disabled: false,
      }));
      setClientFormList(formList);
      if (defaultStartDate) {
        const start = new Date(defaultStartDate);
        start.setDate(new Date(defaultStartDate).getDate() + 1);
        setStartDate(start.toLocaleDateString("sv-SE"));
        setMinDate(start.toLocaleDateString("sv-SE"));
      } else
        setStartDate(
          new Date(
            dataClientForm.formListForClient[0].clientId.termStartDate
          ).toLocaleDateString("sv-SE")
        );
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Form Name",
      headerClassName: "super-app-theme--header",
      minWidth: 170,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "date",
      headerClassName: "super-app-theme--header",
      headerName: "Date Created",
      minWidth: 120,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "terms",
      headerClassName: "super-app-theme--header",
      headerName: "Used in Sprints",
      minWidth: 170,
      flex: 2,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "select",
      headerClassName: "super-app-theme--header",
      headerName: "Select",
      minWidth: 70,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        return rows.row.status === "Published" ? (
          <Checkbox
            onChange={handleCheckBoxChange}
            id={rows.row.id}
            defaultChecked={rows.row.checked}
            disabled={rows.row.disabled}
          />
        ) : (
          ""
        );
      },
    },
  ];

  const rows = clientFormList
    .filter(frm => frm.approved === true)
    .map((frm, index) => ({
      index,
      id: frm.formId,
      name: frm.name,
      date: dayFormat(frm.createDate),
      terms: frm.termList,
      status: "Published", // Since only approved forms are included
      checked: frm.checked,
      disabled: frm.disabled,
    }));

  const handleCheckBoxChange = e => {
    let checked = false;
    let disabled = true;
    if (e.target.checked) {
      setSelectedForm(e.target.id);
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        form: "",
      }));
    } else {
      setSelectedForm(0);
      //checked = false;
    }
    let chgClientForm = clientFormList;
    //if unchecked enable other checkboxes otherwise disabled them
    for (let i = 0; i < clientFormList.length; i++) {
      if (clientFormList[i].approved == true && e.target.id != clientFormList[i].formId) {
        if (e.target.checked == true) {
          checked = false;
          disabled = true;
        } else {
          checked = false;
          disabled = false;
        }

        chgClientForm = findAnd.changeProps(
          chgClientForm,
          { formId: clientFormList[i].formId },
          {
            disabled: disabled,
            checked: checked,
          }
        );
      }
    }

    setClientFormList(chgClientForm);
  };

  const handleDone = async () => {
    let submitForm = true;
    if (startDate == "") {
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        startDate: "Start Date cannot be blank",
      }));
      submitForm = false;
    }
    if (selectedForm == 0) {
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        form: "Please select a form",
      }));
      submitForm = false;
    }
    if (!termName || termName.trim() === "") {
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        termName: "This is a required field",
      }));
      submitForm = false;
    }
    if (!selectedTemplateName || selectedTemplateName === "") {
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        template: "This is a required field",
      }));
      submitForm = false;
    }
    console.log(submitForm);
    if (submitForm) {
      let termStartDate = new Date(startDate).toISOString().slice(0, 10);
      console.log(selectedTemplateName);
      const { data, error } = await createFirstTerm({
        variables: {
          name: termName,
          formId: parseInt(selectedForm),
          startDate: termStartDate,
          noOfSeats: parseInt(noOfSeats),
          template: selectedTemplateName,
        },
      });
      if (error) {
        if (
          error.graphQLErrors[0].message ===
          "This name is used before. Select a unique name."
        )
          setAlertMsg({
            title: "Error",
            msg: "This name is used before. Select a unique name.",
          });
        else if (error.graphQLErrors[0].message === "Signature has expired")
          navigate(`${project_url}/signin/?next=${pathname}`);
        else {
          console.log("Error", error, data);
          setAlertMsg({
            title: "Error",
            msg: "Unfortunately an error occurred.",
          });
        }
      } else if (data && data.createFirstTerm) {
        console.log("Success", data);
        setAlertMsg({
          title: "Success",
          msg: "New Term has been successfully added.",
        });
        navigate(`${project_url}/terms/${data.createFirstTerm.term.termUuid}`);
      }
    }
  };

  return (
    <div>
      <Dialog
        disablePortal
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "600px",
              height: "600px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box mt={1} ml={1}>
            Add Term
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: theme => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
          <Box mb={2}>
            <Typography variant="h3" style={{ fontSize: 16 }}>
              You are adding a new term for Client: {clientName}
            </Typography>
          </Box>

          <Box pt={1}>
            <FormHelperText style={{ fontSize: 14,color:'black' }}>
              Scroll down to see the Forms section.
            </FormHelperText>
          </Box>

          {errorMsg.form && (
            <Box pt={1}>
              <FormHelperText className={classes.errorStyle} error>
                {errorMsg.form}
              </FormHelperText>
            </Box>
          )}

          <Grid container spacing={1}>
            
            <Grid item xs={8}>
              <DialogContentText id="alert-dialog-description">
                <TextField
                  fullWidth
                  autoFocus
                  label="Term Name"
                  margin="normal"
                  name="termName"
                  variant="outlined"
                  id="termName"
                  value={termName}
                  onChange={handleNameFieldChange}
                  onKeyDown={e => {
                    e.key === "Enter" && handleDone();
                  }}
                />

                {errorMsg.termName && (
                  <FormHelperText className={classes.errorStyle} error>
                    Term Name cannot be blank.
                  </FormHelperText>
                )}
              </DialogContentText>
            </Grid>
            <Grid item xs={8}>
              <form noValidate autoComplete="off">
                <Autocomplete
                  className={classes.autoComStyle}
                  key={selectedVal}
                  onChange={(event, newValue) => {
                    setTermDataByTemplate(newValue);
                  }}
                  options={termTemplateData}
                  PopperComponent={PopperMy}
                  getOptionLabel={option => option}
                  renderInput={params => (
                    <TextField
                      label="Select term template"
                      margin="normal"
                      name="selectOptions"
                      variant="outlined"
                      {...params}
                      id="template"
                    />
                  )}
                />
              </form>
              {errorMsg.template && (
                <FormHelperText className={classes.errorStyle} error>
                  One item must be selected.
                </FormHelperText>
              )}
            </Grid>
            <Grid item xs={5}>
              <DialogContentText id="alert-dialog-description">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    inputRef={startDateRef}
                    value={dayjs(startDate)}
                    label="Start Date"
                    id="startDate"
                    name="startDate"
                    disableOpenPicker={false}
                    onChange={newDate => updateStartEndDates(newDate)}
                    minDate={dayjs(minDate)}
                    renderInput={params => (
                      <TextField
                        {...params}
                        InputProps={{ ...params.InputProps, readOnly: true }}
                        inputProps={{
                          ...params.inputProps,
                          readOnly: true,
                          disabled: true,
                        }}
                        disabled // This disables the entire TextField
                        onKeyDown={e => e.preventDefault()} // Prevents any key input
                        onClick={e => e.preventDefault()} // Prevents focus (optional)
                      />
                    )}
                  />
                </LocalizationProvider>
                {errorMsg.startDate && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.startDate}
                  </FormHelperText>
                )}
              </DialogContentText>
            </Grid>
            <br />
            <Grid
              item
              xs={13}
              style={{ width: "100%", textAlign: "left", marginTop: 15 }}
            >
              <DialogContentText id="alert-dialog-description">
                {endDate && (
                  <Typography variant="h3" style={{ fontSize: 16 }}>
                    End Date: {endDate}
                  </Typography>
                )}
                {!endDate && (
                  <Typography variant="h3" style={{ fontSize: 16 }}>
                    End Date: -
                  </Typography>
                )}
              </DialogContentText>
            </Grid>
            <Grid
              item
              xs={13}
              style={{ width: "100%", textAlign: "left", marginTop: 15 }}
            >
              <DialogContentText id="alert-dialog-description">
                {noOfWeeks && (
                  <Typography variant="h3" style={{ fontSize: 16 }}>
                    No of Weeks: {noOfWeeks}
                  </Typography>
                )}
                {!noOfWeeks && (
                  <Typography variant="h3" style={{ fontSize: 16 }}>
                    No of Weeks: -
                  </Typography>
                )}
              </DialogContentText>
            </Grid>
            <Grid item xs={5}>
              <DialogContentText id="alert-dialog-description">
                <TextField
                  fullWidth
                  label="No of Seats"
                  margin="normal"
                  name="noOfSeats"
                  type="number"
                  defaultValue={1}
                  variant="outlined"
                  onKeyDown={e => {
                    if (e.keyCode >= 65 && e.keyCode <= 90) {
                      e.preventDefault();
                    }
                  }}
                  onChange={e => validateNoOfSeats(e.target.value)}
                  InputProps={{
                    inputProps: { min: 1, max: 99, pattern: "^[1-9][0-9]?$" },
                  }}
                  id="noOfSeats"
                  helperText={errorMsg.noOfSeats}
                  error={errorMsg.noOfSeats}
                  value={noOfSeats}
                />
              </DialogContentText>
            </Grid>
          </Grid>
          <Box pt={1} pb={1} style={{ display: "flex", justifyContent: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20 }}>
              Select a published form for this client: {clientName}
            </Typography>
          </Box>
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            showCellRightBorder={true}
            hideFooter={true}
            autoWidth={true}
            getRowId={row => row.id}
            getRowClassName={params => {
              if (params.row.index % 2 === 0) return "even";
              else return "odd";
            }}
            autoHeight={true}
            experimentalFeatures={{ newEditingApi: true }}
          />
          {errorMsg.form && (
            <Box pt={1}>
              <FormHelperText className={classes.errorStyle} error>
                {errorMsg.form}
              </FormHelperText>
            </Box>
          )}
          {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => setAlertMsg([])}
            />
          )}
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 2 }}
              onClick={handleDone}
            >
              Save Term
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
